<template>
  <div>
    <!-- 创意天地 -->
    <section class="creative-section">
      <div class="container">
        <div class="section-head">
          <h2 class="section-title">{{ $t('overview.creativeHub.title') }}</h2>
          <p class="section-sub">{{ $t('overview.creativeHub.subtitle') }}</p>
        </div>
      </div>
    </section>

    <!-- 案例展示部分 -->
    <section class="showcase-section">
      <div class="container">
        <div class="section-head" style="padding-top: 3rem;">
          <h2 class="section-title">{{ $t('overview.showcase.title') }}</h2>
          <p class="section-sub">{{ $t('overview.showcase.subtitle') }}</p>
        </div>

        <!-- 第一个 案例头部 -->
        <div class="showcase-row">
          <div class="showcase-itemwrap" v-for="(item, idx) in showcaseItems" :key="`card-${idx}`">
            <div class="showcase-card" :key="`card-${idx}`">
              <div class="showcase-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(item.title) }}</h3>
                <p class="showcase-desc">{{ $t(item.desc) }}</p>
              </div>
            </div>
            <div v-if="idx < showcaseItems.length - 1" class="showcase-arrow">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>
        <!-- 第一个 案例底部 -->
        <div class="showcase-cta">
          <el-button type="primary" size="large" class="cta-button" @click="onContact(1)" style="margin-bottom: 30px;">
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>

        <!-- 第二个 案例头部 -->
        <div class="showcase-row">
          <div class="showcase-itemwrap" v-for="(item, idx) in showcase22ItemsResolved" :key="`card2-${idx}`">
            <div class="showcase-card" :key="`card2-${idx}`">
              <div class="showcase-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(item.title) }}</h3>
                <p class="showcase-desc">{{ $t(item.desc) }}</p>
              </div>
            </div>
            <div v-if="idx < showcase22ItemsResolved.length - 1" class="showcase-arrow">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>
        <!-- 第二个：案例底部 -->
        <div class="showcase-cta" style="padding-bottom: 4rem;">
          <el-button type="primary" size="large" class="cta-button" @click="onContact(22)">
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>

        <!-- 第三个 案例头部 -->
        <div class="showcase-row">
          <div class="showcase-itemwrap" v-for="(item, idx) in showcase2Items" :key="`card3-${idx}`">
            <div class="showcase-card" :key="`card3-${idx}`">
              <div class="showcase-image" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(item.title) }}</h3>
                <p class="showcase-desc">{{ $t(item.desc) }}</p>
              </div>
            </div>
            <div v-if="idx < showcase2Items.length - 1" class="showcase-arrow">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>
        <!-- 第三个：案例底部 -->
        <div class="showcase-cta" style="padding-bottom: 4rem;">
          <el-button type="primary" size="large" class="cta-button" @click="onContact(2)">
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>
      </div>
    </section>

    <!-- 专利校对服务部分 -->
    <section class="patent-proofreading-section">
      <div class="container">
        <div class="section-header">
          <h2 class="main-title">{{ $t('overview.proofreading.title') }}</h2>
          <p class="main-desc">{{ $t('overview.proofreading.desc') }}<span style="font-weight: bold;">{{ $t('overview.proofreading.desc2') }}</span>{{ $t('overview.proofreading.desc3') }}</p>
                  <p class="main-desc">{{ $t('overview.proofreading.desc4') }} </p>

        </div>

        <div class="slogan-section">
          <h3 class="slogan">{{ $t('overview.proofreading.sloganTitle') }}</h3>
          <p class="slogan-desc">{{ $t('overview.proofreading.sloganDesc') }}</p>
             <p class="slogan-desc">{{ $t('overview.proofreading.sloganDesc1') }}</p>
        </div>

        <div class="book-showcase">
          <div class="book-image">
            <img :src="zhuanlibookimg" alt="德汉专利翻译教材" />
          </div>
          <div class="book-description">
            <p style="margin-bottom:4rem;font-weight:bold"> {{ $t('overview.proofreading.bookTitle') }}</p>
            <p>{{ $t('overview.proofreading.bookDesc') }}</p>
                <p>{{ $t('overview.proofreading.bookDesc1') }}</p>
          </div>
        </div>

        <div class="book-showcase">
          <div class="book-description">
            <p style="margin-bottom:4rem;font-weight:bold"> {{ $t('overview.proofreading.tacTitle') }}</p>
            <p>{{ $t('overview.proofreading.tacDesc') }}<span style="font-weight: bold;">{{ $t('overview.proofreading.tacDesc1') }}</span>
            {{ $t('overview.proofreading.tacDesc2') }}</p>
               <p>{{ $t('overview.proofreading.tacDesc3') }}</p>
          </div>
          <div class="book-image">
            <img :src="renzhengtacimg" alt="德汉专利翻译教材" />
          </div>
        </div>

        <div class="service-cards">
          <div class="service-card" style="padding: 1rem;">
            <div class="card-icon" style="display: flex;flex-direction: column;align-items: left;"   :style="{
    width: lngStr == '中文' ? '100px' : lngStr == '英语' ? '120px' : '160px'
  }"> 
              <span v-show="$t('overview.proofreading.card1.title0')"> {{ $t('overview.proofreading.card1.title0') }}</span>
              <p  style="width: 100%;align-items: left;padding-left:5px" v-show="$t('overview.proofreading.card1.title')">{{ $t('overview.proofreading.card1.title') }}</p>
              <p  style="width: 100%;align-items: left;padding-left:5px" v-show="$t('overview.proofreading.card1.title1')">{{ $t('overview.proofreading.card1.title1') }}</p>
               <p  style="width: 100%;align-items: left;padding-left:5px" v-show="$t('overview.proofreading.card1.title2')">{{ $t('overview.proofreading.card1.title2') }}</p>
            </div>
                
            <div class="card-content">
              <p>{{ $t('overview.proofreading.card1.desc') }}</p>
                 <p>{{ $t('overview.proofreading.card1.desc1') }}<span style="font-weight: bold;">{{ $t('overview.proofreading.card1.desc2') }}</span>{{ $t('overview.proofreading.card1.desc3') }}</p>

                    <p>{{ $t('overview.proofreading.card1.desc4') }}</p>
            </div>
          </div>
          <div class="service-card" style="padding: 1rem;">
            <div class="card-icon" style="display: flex;flex-direction: column;align-items: left;"  :style="{
    width: lngStr == '中文' ? '100px' : lngStr == '英语' ? '120px' : '160px'
  }">
               <span v-show="$t('overview.proofreading.card2.title0')"> {{ $t('overview.proofreading.card2.title0') }}</span>
              <p   style="width: 100%;align-items: left;padding-left:5px" v-show="$t('overview.proofreading.card2.title')">{{ $t('overview.proofreading.card2.title') }}</p>
               <p   style="width: 100%;align-items: left;padding-left:5px" v-show="$t('overview.proofreading.card2.title1')">{{ $t('overview.proofreading.card2.title1') }}</p>
               <p   style="width: 100%;align-items: left;padding-left:5px" v-show="$t('overview.proofreading.card2.title2')">{{ $t('overview.proofreading.card2.title2') }}</p>
            </div>
            <div class="card-content">
              <p>{{ $t('overview.proofreading.card2.desc') }}</p>
              <p>{{ $t('overview.proofreading.card2.desc1') }}</p>
            </div>
          </div>
        </div>

        <div class="showcase-row">
          <div class="showcase-itemwrap showcase-itemwrap--flat" v-for="(item, idx) in showcase3Items" :key="`cardp-${idx}`">
            <div class="showcase-card" :key="`cardp-${idx}`">
              <div class="showcase-image">
                <img class="showcase-img" :src="item.image" :alt="item.title" />
              </div>
              <div class="showcase-content">
                <h3 class="showcase-title">{{ $t(  item.title ) }} </h3>
                <p class="showcase-desc">{{ item.desc }}</p>
              </div>
            </div>
            <div v-if="idx < showcase3Items.length - 1" class="showcase-arrow">
              <i class="arrow-icon">→</i>
            </div>
          </div>
        </div>

        <div class="showcase-cta">
          <el-button type="primary" size="large" class="cta-button" @click="onContact(3)">
            <i class="el-icon-s-promotion"></i>
            {{ $t('overview.learnMore') }}
          </el-button>
        </div>
      </div>
    </section>

    <!-- 新增瑞士欧瑞康案例 -->
    <div class="oerlikon-case-section">
      <div class="case-container">
        <div class="company-intro">
          <div class="company-header">
            <div class="company-logo">
              <img src="@/assets/images/homepageimg/fanlianli01.png" alt="Oerlikon Logo" class="logo-img" />
            </div>
            <div class="company-description">
              <p class="intro-text">
                <span class="company-name">{{ $t('overview.Oerlikon01') }}</span>{{ $t('overview.Oerlikon02') }}
                <span class="highlight">{{ $t('overview.Oerlikon03') }}</span>{{ $t('overview.Oerlikon04') }}
                <span class="highlight">{{ $t('overview.Oerlikon05') }}</span>{{ $t('overview.Oerlikon06') }}
                <span class="company-name">{{ $t('overview.Oerlikon07') }}</span> {{ $t('overview.Oerlikon08') }}
              </p>
              <p class="cooperation-text">
                {{ $t('overview.Oerlikon09') }}<span class="highlight-orange">{{ $t('overview.Oerlikon10') }}</span>{{ $t('overview.Oerlikon11') }}
              </p>
            </div>
          </div>

          <div class="cooperation-details">
            <p class="details-text">
              {{ $t('overview.Oerlikon12') }}
              <span class="highlight-orange">{{ $t('overview.Oerlikon13') }}</span>{{ $t('overview.Oerlikon14') }}<span class="highlight-orange">
                {{ $t('overview.Oerlikon15') }}</span>
            </p>
            <p class="service-text">
              {{ $t('overview.Oerlikon16') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 无效诉讼案例部分 -->
    <section class="invalid-cases-section">
      <div class="container">
        <div class="section-header">
          <h2 class="main-title" style="margin-top:2rem">
            {{ $t('overview.apple01') }}<span style="color:#FF631E">{{ $t('overview.apple02') }}</span>{{ $t('overview.apple03') }}
          </h2>
        </div>
        <p class="main-desc"  style="margin-top: 5px;">
          {{ $t('overview.apple04') }}<span style="font-weight: bold;">{{ $t('overview.apple05') }}</span>{{ $t('overview.apple06') }}
        </p>
        <p class="main-desc"  style="margin-bottom: 20px;margin-top: 6px;"> {{ $t('overview.apple061') }}</p>
        <div class="invalid-images">
          <img :src="invalidImage01" alt="无效诉讼案例展示1" style="width: 200px;object-fit: contain" />
          <div class="showcase-arrow"><i class="arrow-icon">↔</i></div>
          <div style="display:flex; flex-direction: column;">
            <img :src="invalidImage021" alt="无效诉讼案例展示2" style="width: 300px;object-fit: contain" />
            <img :src="invalidImage022" alt="无效诉讼案例展示2" style="width: 300px;object-fit: contain" />
          </div>
          <div class="showcase-arrow"><i class="arrow-icon">↔</i></div>
          <img :src="invalidImage03" alt="无效诉讼案例展示3" style="width: 200px;object-fit: contain" />
        </div>

        <div class="section-header">
          <h2 class="main-title" style="margin-top:3rem">
            {{ $t('overview.addias01') }}<span style="color:#FF631E">{{ $t('overview.addias02') }}</span>{{ $t('overview.addias03') }}
          </h2>
        </div>
        <p class="main-desc">
          {{ $t('overview.addias04') }}<span style="font-weight: bold;">{{ $t('overview.addias05') }}</span>{{ $t('overview.addias06') }}<span
            style="font-weight: bold;">{{ $t('overview.addias07') }}</span>{{ $t('overview.addias08') }}
        </p>
  <p class="main-desc">
          {{ $t('overview.addias0401') }} 
        </p>
          <p class="main-desc">
          {{ $t('overview.addias0402') }} 
        </p>
        <div class="invalid-images">
          <img :src="invalidImage1" alt="无效诉讼案例展示1" style="width: 200px;object-fit: contain" />
          <div class="showcase-arrow"><i class="arrow-icon">↔</i></div>
          <img :src="invalidImage2" alt="无效诉讼案例展示2" style="width: 200px;object-fit: contain" />
          <div class="showcase-arrow"><i class="arrow-icon">↔</i></div>
          <img :src="invalidImage3" alt="无效诉讼案例展示3" style="width: 200px;object-fit: contain" />
        </div>
      </div>
    </section>

    <!-- 成功案例展示 -->
    <section class="success-case-section">
      <div class="container">
        <div class="section-header">
          <h2 class="case-title">{{ $t('overview.dlmdia01') }}</h2>
        </div>
        <div class="case-layout">
          <div class="case-images">
            <div class="image-top">
              <img src="@/assets/images/gailan/anli05.png" alt="案例图片1" class="case-image" />
            </div>
            <div class="image-bottom">
              <img src="@/assets/images/gailan/anli06.png" alt="案例图片2" class="case-image" />
            </div>
          </div>

          <div class="case-content">
            <div class="case-text">
              <p><strong>{{ $t('overview.dlmdia02') }}</strong>{{ $t('overview.dlmdia03') }}
                <span style="font-weight: bold;">{{ $t('overview.dlmdia04') }}</span> {{ $t('overview.dlmdia05') }}
              </p>

              <p style="margin-top: 3.4rem;"><strong>{{ $t('overview.dlmdia06') }}</strong>{{ $t('overview.dlmdia07') }}
                <span style="font-weight: bold;">{{ $t('overview.dlmdia08') }}</span> {{ $t('overview.dlmdia09') }}
                <span style="font-weight: bold;">{{ $t('overview.dlmdia10') }}</span>
              </p>

              <p style="margin-top: 3.4rem;">{{ $t('overview.dlmdia11') }}
                <span style="font-weight: bold;">{{ $t('overview.dlmdia12') }}</span>{{ $t('overview.dlmdia13') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 高价值评估案例 -->
    <section class="high-value-patent-section">
      <div class="container">
        <div class="section-header">
          <h2 class="patent-title">{{ $t('overview.textoc05') }}</h2>
        </div>

        <div class="patent-images-grid">
          <div class="patent-image-item">
            <img src="@/assets/images/gailan/anli07.png" class="patent-image" />
          </div>
          <div class="patent-image-item">
            <img src="@/assets/images/gailan/anli09.png" class="patent-image" />
          </div>
          <div class="patent-image-item">
            <img src="@/assets/images/gailan/anli10.png" class="patent-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们弹窗（组件内置） -->
    <el-dialog :visible.sync="dialogVisible" width="85%" :show-close="false" top="1vh" custom-class="contact-dialog">
      <div class="dialog-content">
        <div class="dialog-header" v-show="anliNum == 1 || anliNum == 2 || anliNum == 22">
          <h2 class="dialog-title">{{ $t('overview.textoa1') }}</h2>
          <p class="dialog-subtitle">{{ $t('overview.textoa2') }}</p>
        </div>
        <div class="dialog-header" v-show="anliNum == 3">
          <h2 class="dialog-title" style="color: red;">{{$t('overview.fanyi04')}}</h2>
          <p class="dialog-subtitle"></p>
        </div>
        <div class="dialog-body">
          <div class="image-gallery">
            <div class="gallery-item">
              <img :src="(anliNum === 1 && showcaseItems[0].image) || (anliNum === 2 && showcase2Items[0].image) || (anliNum === 22 && showcase22ItemsResolved[0].image) || (anliNum === 3 && showcase33Items[0].image)" class="gallery-image">
              <div class="item-caption">{{ anliNum == 1 || anliNum == 2 || anliNum == 22 ? $t('overview.textoa3') : $t('overview.fanyi01')   }}</div>
            </div>
            <div class="gallery-item">
              <img :src="(anliNum === 1 && showcaseItems[1].image) || (anliNum === 2 && showcase2Items[1].image) || (anliNum === 22 && showcase22ItemsResolved[1].image) || (anliNum === 3 && showcase33Items[1].image)" class="gallery-image">
              <div class="item-caption">{{ anliNum == 1 || anliNum == 2 || anliNum == 22 ? $t('overview.textoc04') :$t('overview.fanyi02') }}</div>
            </div>
            <div class="gallery-item">
              <img :src="(anliNum === 1 && showcaseItems[2].image) || (anliNum === 2 && showcase2Items[2].image) || (anliNum === 22 && showcase22ItemsResolved[2].image) || (anliNum === 3 && showcase33Items[2].image)" class="gallery-image">
              <div class="item-caption">{{ anliNum == 1 || anliNum == 2 || anliNum == 22 ? $t('overview.textoc02') : $t('overview.fanyi03')  }}</div>
            </div>
          </div>

          <div class="text-content" v-show="anliNum == 1 || anliNum == 2 || anliNum == 22">
            <div style="font-weight:bold;font-size: 18px;color:balck">{{ $t('overview.textoa4') }}</div>
            <div v-show="anliNum == 1">
              <div>{{ $t('overview.textoa5') }}:</div>
              <div>① {{ $t('overview.textoa6') }}<span class="highlight-blue">{{ $t('overview.textoa61') }}</span>{{ $t('overview.textoa62') }}</div>
              <div>② <span class="highlight-blue">{{ $t('overview.textoa7') }}</span>{{ $t('overview.textoa71') }}</div>
              <div>③ <span class="highlight-blue">{{ $t('overview.textoa81') }}</span>{{ $t('overview.textoa82') }}<span class="highlight-blue">{{ $t('overview.textoa83') }}</span>{{ $t('overview.textoa84') }}<span class="highlight-blue">{{ $t('overview.textoa85') }}</span>{{ $t('overview.textoa86') }}</div>
            </div>
            <div v-show="anliNum == 22">
              <div>{{ $t('overview.dialog210') }}</div>
              <div>{{ $t('overview.textoa5') }}:</div>
              <div>① {{ $t('overview.dialog211') }} <span class="highlight-blue">{{ $t('overview.dialog212') }}</span></div>
              <div>② {{ $t('overview.dialog213') }}<span class="highlight-blue">{{ $t('overview.dialog214') }}</span>{{ $t('overview.dialog215') }}<span class="highlight-blue">{{ $t('overview.dialog216') }}</span></div>
              <div>③ {{ $t('overview.dialog217') }}<span class="highlight-blue">{{ $t('overview.dialog218') }}</span></div>
              <div>④ {{ $t('overview.dialog219') }}<span class="highlight-blue">{{ $t('overview.dialog220') }}</span>{{ $t('overview.dialog211') }}</div>
            </div>
            <div v-show="anliNum == 2">
              <div>{{ $t('overview.textoa5') }}:</div>
              <div>① {{ $t('overview.dialog301') }}<span class="highlight-blue">{{ $t('overview.dialog302') }}</span>{{ $t('overview.dialog303') }}<span class="highlight-blue">{{ $t('overview.dialog304') }}</span></div>
              <div>② {{ $t('overview.dialog305') }}<span class="highlight-blue">{{ $t('overview.dialog306') }}</span>{{ $t('overview.dialog307') }}</div>
              <div>③ {{ $t('overview.dialog308') }}<span class="highlight-blue">{{ $t('overview.dialog309') }}</span></div>
            </div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:56px" v-show="anliNum == 1">{{ $t('overview.textoa9') }}</div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:16px" v-show="anliNum == 22">{{ $t('overview.textoa9') }}</div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:56px" v-show="anliNum == 2">{{ $t('overview.textoa9') }}</div>
            <p v-show="anliNum == 1">
              {{ $t('overview.textoa101') }}<span class="highlight-blue">{{ $t('overview.textoa102') }}</span>{{ $t('overview.textoa103') }}<span class="highlight-blue">{{ $t('overview.textoa104') }}</span>{{ $t('overview.textoa105') }}<span class="highlight-blue">{{ $t('overview.textoa106') }}</span>{{ $t('overview.textoa107') }}<span class="highlight-blue">{{ $t('overview.textoa108') }}</span>{{ $t('overview.textoa109') }}<span class="highlight-blue">{{ $t('overview.textoa110') }}</span>
            </p>
            <p v-show="anliNum == 22">
              {{ $t('overview.dialog202') }} <span class="highlight-blue">{{ $t('overview.dialog203') }}</span>{{ $t('overview.dialog204') }}<span class="highlight-blue">{{ $t('overview.dialog205') }}</span>{{ $t('overview.dialog206') }}
            </p>
            <p v-show="anliNum == 2" style="margin-top: 2rem;">
              {{ $t('overview.textoc07') }}<span class="highlight-blue">{{ $t('overview.textoc08') }}</span>{{ $t('overview.textoc09') }}
            </p>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:34px" v-show="anliNum == 1 || anliNum == 22">{{ $t('overview.textoc03') }}</div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:80px" v-show="anliNum == 2">{{ $t('overview.textoc03') }}</div>
            <p v-show="anliNum == 1">{{ $t('overview.textoc011') }}<span class="highlight-blue">{{ $t('overview.textoc012') }}</span>{{ $t('overview.textoc013') }}</p>
            <p v-show="anliNum == 22">{{ $t('overview.dialog201') }}</p>
            <p v-show="anliNum == 2">{{ $t('overview.textoc06') }}</p>
          </div>

          <div class="text-content" v-show="anliNum == 3">
            <div style="font-weight:bold;font-size: 18px;color:balck">{{$t('overview.fanyi05')}}</div>
            <p>{{$t('overview.fanyi07')}}</p>
             <div style="font-weight: bold;">{{$t('overview.fanyi071')}}</div>
              <div>{{$t('overview.fanyi072')}}</div>
            <p>{{$t('overview.fanyi08')}}</p>
            <div style="font-weight: bold;">{{$t('overview.fanyi081')}}</div>
              <div>{{$t('overview.fanyi082')}}</div>
                <div>{{$t('overview.fanyi083')}}</div>
            <div style="font-weight:bold;font-size: 18px;color:balck;margin-top:45px">{{$t('overview.fanyi06')}}</div>
            <div>
              {{$t('overview.fanyi09')}}
              <div>{{$t('overview.fanyi10')}}<span style="color:red">{{$t('overview.fanyi11')}}</span>{{$t('overview.fanyi12')}}
                <span style="color:red">{{$t('overview.fanyi13')}}</span></div>
              <div>  {{$t('overview.fanyi14')}}<span style="color:red">{{$t('overview.fanyi15')}}</span></div>
              <div> {{$t('overview.fanyi16')}}<span style="color:red">{{$t('overview.fanyi15')}}</span></div>
              <div> {{$t('overview.fanyi17')}}<span style="color:red">{{$t('overview.fanyi15')}}</span></div>
              <div>{{$t('overview.fanyi18')}}</div>
              <div style="font-weight: bold;">{{$t('overview.fanyi21')}}</div>
              <div>{{$t('overview.fanyi22')}}</div>
               <div style="font-weight: bold;">{{$t('overview.fanyi23')}}</div>
              <div>{{$t('overview.fanyi24')}}</div>
                 <div>{{$t('overview.fanyi25')}}</div>
            </div>
            <p style="margin-top:0.8rem">{{$t('overview.fanyi19')}}</p>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">{{$t('closestr')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'OverviewShowcaseGroup',
  emits: ['contact'],
  props: {
    // 1=默认 创意3.1.png；2=使用 创意3.11.png
    showcaseImgVariant: {
      type: [Number, String],
      default: 1
    }
  },
  data() {
    return {
      lngStr:'中文',
      // 无效诉讼图片
      invalidImage01: require('@/assets/images/gailan/susong1.png'),
      invalidImage021: require('@/assets/images/gailan/susong2.png'),
      invalidImage022: require('@/assets/images/gailan/susong3.png'),
      invalidImage03: require('@/assets/images/gailan/susong4.png'),
      invalidImage1: require('@/assets/images/homepageimg/无效专利图1.png'),
      invalidImage2: require('@/assets/images/homepageimg/无效专利图2.png'),
      invalidImage3: require('@/assets/images/homepageimg/无效专利图3.png'),
      zhuanlibookimg: require('@/assets/images/homepageimg/德汉教材.png'),
      renzhengtacimg: require('@/assets/images/homepageimg/tacimg.png'),
      // 案例展示数据
      showcaseItems: [
        { title: 'overview.anli101', desc: 'overview.anli102', image: require('@/assets/images/homepageimg/创意1.1.png') },
        { title: 'overview.anli201', desc: 'overview.anli202', image: require('@/assets/images/homepageimg/创意1.2.png') },
        { title: 'overview.anli301', desc: 'overview.anli302', image: require('@/assets/images/homepageimg/创意1.3.png') }
      ],
      showcase22Items: [
        { title: 'overview.anli101', desc: 'overview.anli102', image: require('@/assets/images/homepageimg/创意3.1.png') },
        { title: 'overview.anli201', desc: 'overview.anli202', image: require('@/assets/images/homepageimg/创意3.2.png') },
        { title: 'overview.anli301', desc: 'overview.anli302', image: require('@/assets/images/homepageimg/创意3.3.png') }
      ],
      showcase2Items: [
        { title: 'overview.anli101', desc: 'overview.anli102', image: require('@/assets/images/homepageimg/创意2.1.png') },
        { title: 'overview.anli201', desc: 'overview.anli202', image: require('@/assets/images/homepageimg/创意2.2.png') },
        { title: 'overview.anli301', desc: 'overview.anli302', image: require('@/assets/images/homepageimg/创意2.3.png') }
      ],
      showcase3Items: [
        { title: 'overview.fanyi01', desc: '', image: require('@/assets/images/homepageimg/1h原文.png') },
        { title: 'overview.fanyi02', desc: '', image: require('@/assets/images/homepageimg/2h原译文.png') },
        { title: 'overview.fanyi03', desc: '', image: require('@/assets/images/homepageimg/3h建议译文.png') }
      ],
      showcase33Items: [
        { title: 'overview.fanyi01', desc: '', image: require('@/assets/images/homepageimg/fanyi1原文.png') },
        { title: 'overview.fanyi02', desc: '', image: require('@/assets/images/homepageimg/fanyi2原译文.png') },
        { title: 'overview.fanyi03', desc: '', image: require('@/assets/images/homepageimg/fanyi3建议译文.png') }
      ],
      anliNum: 1,
      dialogVisible: false
    }
  },
  watch: {
     // 监听语言变化，确保组件响应式更新
    '$i18n.locale'() {
      // 强制更新组件以确保所有翻译文本立即更新
      this.loadTeamMembers()
    },
    
  },
  computed: {
    // 基于入参动态替换第二组案例的首图
    showcase22ItemsResolved() {
      const arr = this.showcase22Items.map(i => ({ ...i }))
      arr[0] = {
        ...arr[0],
        image: this.showcaseImgVariant == 2
          ? require('@/assets/images/homepageimg/创意3.11.png')
          : require('@/assets/images/homepageimg/创意3.1.png')
      }
      return arr
    },
      
  },
  methods: {
    loadTeamMembers(){
      console.log('Current Language:', this.getCurrentLanguage());
      this.lngStr=this.getCurrentLanguage()
    },

        getCurrentLanguage() {
      const locale =
        (this.$i18n && this.$i18n.locale) ||
        (this.$root && this.$root.$i18n && this.$root.$i18n.locale) ||
        '';

      if (['zh', 'zh-CN', 'zh-Hans'].includes(locale)) return '中文';
      if (['en', 'en-US', 'en-GB'].includes(locale)) return '英语';
      if (['de', 'de-DE'].includes(locale)) return '德语';

      // 兜底：根据浏览器语言判断
      const lang = (navigator.language || '').toLowerCase();
      if (lang.startsWith('zh')) return '中文';
      if (lang.startsWith('en')) return '英语';
      if (lang.startsWith('de')) return '德语';
      return '中文';
    },
    onContact(num) {
      this.anliNum = num
      this.dialogVisible = true
      this.$emit('contact', num)
    }
  }
}
</script>

<style scoped>
/* 基础容器（与父级一致宽度约束） */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 创意天地 */
.creative-section {
  padding: 2rem 0;
  background-image: url('~@/assets/images/homepageimg/创意天地.jpg');
  background-size: cover;
  background-position: center;
  position: relative;
}
.creative-section::before {
  content: '';
  position: absolute; inset: 0;
  background: rgba(0, 0, 0, 0.5);
}
.creative-section .container { position: relative; }
.section-head { text-align: center; margin-bottom: 1.5rem; }
.section-sub { color: #666; font-size: 0.95rem; }
.creative-section .section-title, .creative-section .section-sub { color: #fff; }

/* 案例展示部分 */
.showcase-section { padding: 0rem 0; background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%); }
.showcase-section .section-head { text-align: center; margin-bottom: 3rem; }
.showcase-section .section-title { font-size: 2rem; color: #333; margin-bottom: 1rem; font-weight: 600; }
.showcase-section .section-sub { color: #666; font-size: 1rem; line-height: 1.8; max-width: 900px; margin: 0 auto; }
.showcase-row { display: flex; justify-content: center; align-items: center; gap: 2rem; margin-bottom: 3rem; }
.showcase-card { background: #fff; border-radius: 16px; overflow: hidden; box-shadow: 0 8px 32px rgba(0,0,0,0.08); transition: transform .3s ease, box-shadow .3s ease; flex: 0 0 280px; }
.showcase-card:hover { transform: translateY(-8px); box-shadow: 0 16px 48px rgba(0,0,0,0.12); }
.showcase-image { height: 200px; background-size: cover; background-position: center; position: relative; overflow: hidden; }
.showcase-img { width: 100%; height: 100%; object-fit: contain; display: block; }
.showcase-content { padding: 1.5rem; }
.showcase-title { font-size: 1.2rem; font-weight: 600; color: #333; margin-bottom: 0.8rem; }
.showcase-desc { font-size: 0.9rem; color: #666; line-height: 1.6; margin: 0; }
.showcase-arrow { display: flex; justify-content: center; align-items: center; height: 60px; }
.arrow-icon { font-size: 2.4rem; color: #FF631E; font-weight: bold; font-style: normal; }
.showcase-cta { text-align: center; }
.cta-button { background: linear-gradient(135deg, #FF631E, #ff7a3d); border: none; padding: 1rem 2.5rem; font-size: 1.1rem; font-weight: 600; border-radius: 50px; box-shadow: 0 6px 20px rgba(255,99,30,0.3); transition: all .3s ease; }
.cta-button:hover { transform: translateY(-2px); box-shadow: 0 8px 25px rgba(255,99,30,0.4); }

/* 专利校对服务部分 */
.patent-proofreading-section { padding: 1rem 0; background: #f8f9fa; }
.patent-proofreading-section .section-header { text-align: center; margin-bottom: 3rem; }
.patent-proofreading-section .main-title { font-size: 2.2rem; color: #333; margin-bottom: 1rem; font-weight: 600; }
.patent-proofreading-section .main-desc { color: #666; font-size: 1rem; line-height: 1.8; max-width: 900px; margin: 0 auto; text-align: left;}
.slogan-section { text-align: center; margin-bottom: 3rem; }
.slogan { font-size: 1.8rem; color: #333; margin-bottom: 1rem; font-weight: 600; }
.slogan-desc { color: #666; font-size: 0.95rem; line-height: 1.8; max-width: 900px; margin: 0 auto;text-align: left; }
.service-cards { display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; margin-bottom: 3rem; }
.service-card { background: #fff; border-radius: 12px; padding: 2rem; box-shadow: 0 4px 20px rgba(0,0,0,0.08); display: flex; align-items: flex-start; gap: 1rem; }
.card-icon {word-break: break-all; overflow-wrap: break-word;white-space: normal;width: 155px; height: 90px; background: #333; color: #fff; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; font-weight: 600; flex-shrink: 0; }
.card-content p { color: #666; font-size: 0.95rem; line-height: 1.6; margin: 0; }
.book-showcase { display: flex; align-items: center; gap: 2rem; margin-bottom: 3rem; background: #fff; border-radius: 12px; padding: 2rem; box-shadow: 0 4px 20px rgba(0,0,0,0.08); }
.book-image { flex: 0 0 200px; }
.book-image img { width: 100%; border-radius: 8px; }
.book-description p { color: #666; font-size: 0.95rem; line-height: 1.8; margin: 0; text-align: justify; }

/* 欧瑞康案例 */
.oerlikon-case-section { margin: 0px 0; padding: 40px 20px 50px 20px; background: #f8f9fa; }
.case-container { max-width: 1200px; margin: 0 auto; background: white; border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.08); overflow: hidden; }
.company-intro { padding: 40px; background: linear-gradient(135deg,#ffffff 0%,#f8f9fa 100%); }
.company-header { display: flex; align-items: flex-start; gap: 30px; margin-bottom: 30px; }
.company-logo { flex-shrink: 0; }
.logo-img { width: 200px; height: auto; padding-top: 0.6rem; }
.company-description { flex: 1; }
.intro-text { font-size: 16px; line-height: 1.8; color: #333; margin-bottom: 20px; text-align: justify; }
.company-name { font-weight: bold; color: #e74c3c; font-size: 18px; }
.highlight { color: #e74c3c; font-weight: bold; font-size: 18px; }
.highlight-orange { color: #FF631E; font-weight: bold; }
.cooperation-text { font-size: 16px; line-height: 1.8; color: #333; background: linear-gradient(90deg, #fff3cd, #ffffff); padding: 15px 20px; border-left: 4px solid #f39c12; border-radius: 8px; margin-top: 20px; }
.cooperation-details { margin-top: 30px; }
.details-text,.service-text { font-size: 15px; line-height: 1.8; color: #555; margin-bottom: 20px; text-align: justify; padding: 20px; background: rgba(255,255,255,0.8); border-radius: 10px; border: 1px solid #e9ecef; }

/* 无效诉讼部分 */
.invalid-cases-section { padding: 1rem 0; background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%); }
.invalid-cases-section .section-header { text-align: center; margin-bottom: 2rem; }
.invalid-cases-section .main-title { font-size: 2.0rem; color: #333; margin-bottom: 1rem; font-weight: 600; }
.invalid-cases-section .main-desc { color: #666; font-size: 1.1rem; line-height: 1.8; font-weight: 500;   }
.invalid-images { display: flex; justify-content: space-between; align-items: center; gap: 1rem; background: #fff; border-radius: 16px; padding: 2rem; box-shadow: 0 8px 32px rgba(0,0,0,0.08); }
.invalid-images img { flex: 1; width: 100%; height: 300px; object-fit: cover; border-radius: 8px; }

/* 成功案例展示 */
.success-case-section { padding: 4rem 0; background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%); }
.success-case-section .section-header { text-align: center; margin-bottom: 3rem; }
.case-title { font-size: 2.2rem; font-weight: 700; color: #1a202c; margin-bottom: 1rem; line-height: 1.4; position: relative; display: inline-block; }
.case-layout { display: flex; gap: 3rem; align-items: flex-start; }
.case-images { flex: 0 0 29%; display: flex; flex-direction: column; gap: 1.5rem; height: 33rem; }
.image-top, .image-bottom { border-radius: 12px; overflow: hidden; box-shadow: 0 4px 15px rgba(0,0,0,0.1); transition: transform .3s ease, box-shadow .3s ease; }
.image-top:hover, .image-bottom:hover { transform: translateY(-5px); box-shadow: 0 8px 25px rgba(0,0,0,0.15); }
.case-image { width: 100%; height: 100%; object-fit: contain; display: block; }
.case-content { flex: 0 0 72%; background: white; border-radius: 16px; padding: 2.5rem; box-shadow: 0 8px 30px rgba(0,0,0,0.08); border: 1px solid #e2e8f0; }
.case-text p { font-size: 1.3rem; line-height: 1.8; color: #4a5568; margin-bottom: 1.5rem; text-align: justify; }
.case-text strong { color: #FF631E; font-weight: 600; }

/* 高价值评估案例 */
.high-value-patent-section { padding: 4rem 0; background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); position: relative; }
.high-value-patent-section .section-header { text-align: center; margin-bottom: 3rem; position: relative; z-index: 1; }
.patent-title { font-size: 2.2rem; font-weight: 700; color: #1a202c; margin-bottom: 1rem; line-height: 1.4; position: relative; display: inline-block; }
.patent-images-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 2rem; margin-bottom: 2.5rem; position: relative; z-index: 1; height: 33rem; }
.patent-image-item { background: white; border-radius: 16px; overflow: hidden; box-shadow: 0 8px 25px rgba(0,0,0,0.1); transition: all .3s ease; border: 1px solid #e2e8f0; position: relative; }
.patent-image-item:hover { transform: translateY(-8px); box-shadow: 0 15px 35px rgba(0,0,0,0.15); }
.patent-image { width: 100%; height: 100%; object-fit: contain; display: block; transition: transform .3s ease; }
.patent-image-item:hover .patent-image { transform: scale(1.05); }

/* 响应式（节选） */
@media (max-width: 992px) {
  .container { width: 90%; padding: 0 1rem; }
  .showcase-row { flex-direction: column; gap: 1.5rem; align-items: center; }
  .showcase-card { width: 100%; max-width: 400px; flex: 0 0 auto; }
  .showcase-arrow { transform: rotate(90deg); height: 40px; }
  .arrow-icon { font-size: 1.5rem; }
  .service-cards { grid-template-columns: 1fr; }
  .invalid-images { flex-direction: column; }
  .invalid-images img { height: 200px; }
}

@media (max-width: 768px) {
  .showcase-image { height: 160px; }
  .showcase-card { width: 100%; max-width: 320px; }
  .cta-button { padding: 0.875rem 2rem; font-size: 1rem; }
  .patent-proofreading-section { padding: 3rem 0; }
  .service-card { padding: 1.5rem; }
  .book-showcase { flex-direction: column; text-align: center; gap: 1.5rem; padding: 1.5rem; }
  .book-image { flex: none; align-self: center; }
  .book-image img { max-width: 200px; width: auto; }
  .book-description { text-align: center; }
  .success-case-section { padding: 3rem 0; }
  .case-layout { flex-direction: column; gap: 2rem; }
  .case-images { flex: none; width: 100%; flex-direction: row; gap: 1rem; }
  .image-top, .image-bottom { height: 200px; }
  .case-content { padding: 2rem; width: 100%; }
}

@media (max-width: 480px) {
  .showcase-card { max-width: 280px; }
  .showcase-image { height: 140px; }
  .showcase-content { padding: 1rem; }
  .showcase-title { font-size: 1rem; }
  .showcase-desc { font-size: 0.85rem; }
  .book-image img { max-width: 150px; }
  .patent-images-grid { grid-template-columns: 1fr; gap: 1rem; height: auto; }
}
.showcase-itemwrap { display: flex; align-items: center; gap: 2rem; }
.showcase-itemwrap--flat { display: contents; }

/* 弹窗样式（迁移） */
.contact-dialog .el-dialog__header { display: none; }
.contact-dialog .el-dialog__body { padding: 0; border-radius: 15px; }
.dialog-content { padding: 2rem 2.5rem; background: #f8f9fa; }
.dialog-header { text-align: center; margin-bottom: 2rem; }
.dialog-title { font-size: 2rem; font-weight: 700; color: #333; margin-bottom: 0.5rem; }
.dialog-subtitle { font-size: 1rem; color: #666; }
.dialog-body { display: flex; gap: 2.5rem; align-items: flex-start; }
.dialog-body .image-gallery { display: flex; flex-direction: column; gap: 1rem; flex: 0 0 420px; }
.gallery-item { display: flex; align-items: center; gap: 1rem; padding: 1rem; text-align: left; border-radius: 12px; background: #fff; box-shadow: 0 4px 15px rgba(0,0,0,0.08); transition: transform .3s ease, box-shadow .3s ease; }
.gallery-item:hover { transform: translateY(-5px); box-shadow: 0 8px 25px rgba(0,0,0,0.12); }
.gallery-item img { width: 18.75rem; border-radius: 8px; flex-shrink: 0; }
.gallery-image { height: 9.375rem; object-fit: contain; }
.gallery-item .item-caption { font-size: 1rem; font-weight: 600; color: #333; }
.dialog-body .text-content { flex: 1; min-width: 0; text-align: justify; font-size: 0.95rem; line-height: 1.8; color: #555; }
.dialog-body .text-content p { margin-bottom: 1rem; }
.dialog-footer { text-align: center; margin-top: 0rem; }

/* 响应式（节选） */
@media (max-width: 768px) {
  .dialog-body { flex-direction: column; gap: 1.5rem; }
  .dialog-body .image-gallery { flex: none; width: 100%; }
  .dialog-body .text-content { flex: none; width: 100%; }
  .gallery-item { flex-direction: column; text-align: center; padding: 0.75rem; }
  .gallery-item img { width: 100%; max-width: 250px; }
  .gallery-image { height: 100px; }
  .gallery-item .item-caption { margin-top: 0.75rem; margin-left: 0; font-size: 0.9rem; }
}
@media (max-width: 640px) {
  .dialog-content { padding: 2rem 1.5rem; }
  .dialog-body { flex-direction: column; gap: 2rem; }
  .gallery-item { flex-direction: row; text-align: left; padding: 1rem; }
  .gallery-item img { width: 150px; max-width: 150px; flex-shrink: 0; }
  .gallery-image { height: 100px; }
  .gallery-item .item-caption { margin-top: 0; margin-left: 1rem; font-size: 0.95rem; }
}
@media (max-width: 480px) {
  .contact-dialog .el-dialog { width: 95% !important; margin: 0 auto; }
  .dialog-content { padding: 1.5rem 1rem; }
  .dialog-title { font-size: 1.5rem; }
  .dialog-body { gap: 1rem; }
  .dialog-body .text-content { font-size: 0.9rem; line-height: 1.6; }
  .gallery-item { padding: 0.5rem; margin-bottom: 0.75rem; }
  .gallery-item img { max-width: 200px; }
  .gallery-image { height: 80px; }
  .gallery-item .item-caption { font-size: 0.85rem; margin-top: 0.5rem; }
}
.highlight-blue {
  color: #FF631E;
  font-weight: 600;
}

</style>